<template>
  <div class="attribute-stats">
    <span class="title">{{ title | capitalize }}</span>
    <template v-if="hasRealData">
      <apexchart
        type="bar"
        :options="chart.options"
        :series="chart.series"
        :height="chartHeight"
      />
      <el-button v-if="data.length > 3" type="text" @click="toggle()">
        <span v-if="showAll">Hide more</span>
        <span v-else>Show more</span>
      </el-button>
    </template>
    <template v-else>
      <p class="text-muted text-xs">
        No data to show
      </p>
    </template>
    <pre v-if="debug">{{ showAll | json }}</pre>
    <pre v-if="debug">{{ chart.series | json }}</pre>
  </div>
</template>

<script>
import { sortBy, sumBy } from 'lodash'
import { number } from '@/filters'

export default {
  props: {
    title: { type: String, default: '' },
    seriesLabel: { type: String, default: '' },
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      showAll: false,
      debug: false,
    }
  },
  computed: {
    total() {
      return sumBy(this.data, 'value')
    },
    visibleData() {
      const data = this.data
      const result = sortBy(data, (item) => {
        return -item.value
      })
      if (!this.showAll && data.length > 3) {
        return result.slice(0, 3)
      } else {
        return result
      }
    },
    categories() {
      return this.visibleData
        .filter((item) => {
          if (!item.name || item.name === 'null' || item.name === 'undefined') {
            return false
          }
          return true
        })
        .map((item) => item.name)
    },
    seriesData() {
      return this.visibleData.map((item) => item.value || 'N/A')
    },
    hasRealData() {
      const hasData = this.data.length > 0
      const hasCategories = this.categories.length > 0
      return hasData && hasCategories
    },
    chart() {
      const total = this.total
      return {
        options: {
          chart: {
            fontFamily: 'Roboto',
            foreColor: '#bababa',
            animations: {
              speed: 250,
              dynamicAnimation: {
                enabled: false,
              },
            },
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          xaxis: {
            categories: this.categories,
          },
          dataLabels: {
            enabled: true,
            textAnchor: 'start',
            style: {
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 'bold',
              colors: ['#fff'],
            },
            formatter: function (val, opt) {
              const perc = getPercentage(val, total)
              return `${val} (${number(perc)}%)`
            },
            offsetX: 0,
            dropShadow: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: this.seriesLabel,
            data: this.seriesData,
          },
        ],
      }
    },
    chartHeight() {
      return Math.max(130, 30 * this.categories.length)
    },
  },
  methods: {
    toggle() {
      this.showAll = !this.showAll
    },
  },
}

function getPercentage(val, total) {
  if (total > 0) {
    return (val * 100) / total
  } else {
    return 0
  }
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';

.attribute-stats {
  .title {
    color: $grey120;
  }
}
</style>
